import { useStore } from "zustand"

import { LoginByCodeForm } from "@/components/account/LoginByCodeForm"
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog"
import { store } from "@/lib/store"

export type EmbedLoginDialogProps = {
  open: boolean
  onOpenChange: (open: boolean) => void
  onSuccess: () => void
}

export function EmbedLoginDialog({
  open,
  onOpenChange,
  onSuccess,
}: EmbedLoginDialogProps) {
  const prefillEmail = useStore(store, (state) => state.embedPrefillEmail)

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-lg" aria-describedby={undefined}>
        <DialogTitle className="text-2xl font-bold text-neutral-800">
          Confirm it&apos;s you
        </DialogTitle>
        <p className="text-sm text-neutral-600">
          To continue securely, we&apos;ll email a one-time code.
        </p>
        <LoginByCodeForm
          email={prefillEmail}
          lockEmail={!!prefillEmail}
          onSuccess={onSuccess}
        />
      </DialogContent>
    </Dialog>
  )
}
